import React from 'react'
import { TrainingDataDescription } from './components/TrainingDataDescription'

export const schema = {
  type: 'string',
  description: <TrainingDataDescription />
}

export const uiSchema = {
  'ui:widget': 'EditorWidget',
  focus: true,
  resizeCssRule: 'none',
  initialRowsCount: 46
}
